// src/plugins/vuetify.js
import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

import he from "vuetify/es5/locale/he";


Vue.use(Vuetify);
export default new Vuetify({
	theme: {
		dark: false,
	},
	icons: {
		iconfont: "mdi"
	},
	lang: {
		locales: {he},
		current: "he",
	},
	rtl: true

});
